import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 2.0",
  "description": "Turborepo 2.0은 JavaScript 및 TypeScript monorepo의 인간공학적 측면에서 중요한 이정표입니다.",
  "date": "2024/6/4",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 2.0은 JavaScript 및 TypeScript 저장소의 개발자 경험을 개선합니다. 주요 기능은 다음과 같습니다:"
  }, {
    "heading": "",
    "content": "새로운 터미널 UI: 상호작용 가능한 작업과 더 명확한 로그"
  }, {
    "heading": "",
    "content": "Watch Mode: 저장소의 모든 도구를 위한 의존성 인식 작업 감시자"
  }, {
    "heading": "",
    "content": "완전히 새로운 문서: 핵심 monorepo 개념, 새로워진 API 참조 및 생태계 도구 가이드"
  }, {
    "heading": "",
    "content": "라이선스 및 유지보수 업데이트: MIT 라이선스로 업그레이드 및 장기 지원 정책 추가"
  }, {
    "heading": "",
    "content": "npx @turbo/codemod migrate를 실행하여 지금 업데이트하거나 npx create-turbo@latest로 시작하세요."
  }, {
    "heading": "",
    "content": "업데이트 지침은 업그레이드 가이드를 참조하세요. 주요 변경 사항은 아래에 나열되어 있습니다."
  }, {
    "heading": "새로운-터미널-ui",
    "content": "Turborepo 1.13에서 개선된 터미널 UI가 개발 속도를 어떻게 향상시킬 수 있는지 알아보기 위해 실험적 인터페이스를 출시했습니다. RFC 프로세스를 통해 여러분의 피드백을 바탕으로 커뮤니티와 함께 개선된 로컬 경험을 설계할 수 있었습니다. 참여해 주신 분들께 감사드립니다."
  }, {
    "heading": "새로운-터미널-ui",
    "content": "오늘, 새로운 UI를 안정 버전으로 출시하며, 이와 함께 많은 요청을 받았던 기능들을 활성화합니다."
  }, {
    "heading": "로그-명확성-개선",
    "content": "2.0 이전에는 turbo가 라이브러리 및 애플리케이션 작업 중에 로그를 스트림으로 출력했습니다. 이는 때때로 압도적일 수 있었는데, 섞인 로그들로 인해 특정 작업에서 무슨 일이 일어나고 있는지 이해하기 어려웠습니다."
  }, {
    "heading": "로그-명확성-개선",
    "content": "이번 UI 반복에서는 화살표 키를 사용하여 개별 작업을 선택하고 한 번에 하나씩 로그를 검사할 수 있어, 집중하고 싶은 로그를 더 쉽게 읽을 수 있습니다."
  }, {
    "heading": "로그-명확성-개선",
    "content": "이전 버전의 turbo에서 사용하던 스트림 로그 보기는 --log-order 플래그를\n사용하여 로컬 개발에서 여전히 사용할 수 있습니다. 이 옵션을 사용하면 작업이\n상호작용하지 않으며 일부 도구가 예기치 않게 터미널을 지울 수 있습니다."
  }, {
    "heading": "상호작용-작업",
    "content": "많은 도구들이 중요한 기능을 위해 스크립트와 상호작용할 수 있도록 허용합니다. 하지만 이전 버전의 Turborepo에서는 스크립트가 turbo 내부에 갇혀 있어 상호작용할 수 없었습니다."
  }, {
    "heading": "상호작용-작업",
    "content": "이제 개별 작업의 셸에 들어가서 인터페이스에 직접 입력하여 stdin을 통해 스크립트에 입력을 전달할 수 있습니다. 이를 통해 Jest 또는 Vitest로 특정 테스트 스위트 실행, Drizzle 또는 Prisma로 데이터베이스 마이그레이션 처리 등의 워크플로우를 사용할 수 있습니다."
  }, {
    "heading": "상호작용-작업",
    "content": "작업을 상호작용으로 표시하려면 정의에 \"persistent\": true를 추가하세요:"
  }, {
    "heading": "상호작용-작업",
    "content": "UI에서 작업을 선택한 상태에서 Enter 키를 사용하여 작업의 셸에 진입하고 CTRL+Z로 종료할 수 있습니다."
  }, {
    "heading": "상호작용-작업",
    "content": "지속적 및 상호작용 작업에 대해 자세히 알아보려면 문서를 방문하세요."
  }, {
    "heading": "watch-mode",
    "content": "Turborepo의 다중 작업 동시 실행 기능은 더 빠른 피드백 루프를 제공하여 신속한 배포를 지원합니다. 로컬에서 작업할 때 Turborepo의 병렬화를 최대한 활용하려면, 변경 사항이 있을 때마다 코드를 다시 실행할 수 있는 \"감시자\" 기능이 도구에 필요합니다. 안타깝게도 많은 일반 도구들이 이 기능을 제공하지 않으며, 대부분의 도구가 monorepo를 인식하지 못해 저장소의 다른 스크립트에 의존하는 스크립트에 문제가 발생합니다."
  }, {
    "heading": "watch-mode",
    "content": "오늘, 모든 도구에 이 기능을 제공하기 위해 Watch Mode를 출시합니다:"
  }, {
    "heading": "watch-mode",
    "content": "turbo watch를 사용하면 Turborepo가 소스 코드 변경 시 작업을 다시 실행합니다. 작업은 turbo run과 마찬가지로 turbo.json의 의존성 그래프 및 구성을 사용하여 실행됩니다."
  }, {
    "heading": "watch-mode",
    "content": "문서에서 Watch Mode에 대해 자세히 알아보세요."
  }, {
    "heading": "완전히-새로운-문서",
    "content": "이번 릴리스와 함께 이전 버전의 강점을 기반으로 한 개선된 문서를 출판합니다. 여러분의 피드백을 반영하여 문서에는 다음이 포함됩니다:"
  }, {
    "heading": "완전히-새로운-문서",
    "content": "더 많은 monorepo 기본 사항 및 사용 방법"
  }, {
    "heading": "완전히-새로운-문서",
    "content": "선호하는 도구를 Turborepo와 통합하는 가이드"
  }, {
    "heading": "완전히-새로운-문서",
    "content": "더 명확한 정보 구조 및 개선된 검색"
  }, {
    "heading": "완전히-새로운-문서",
    "content": "Turborepo 문서를 방문하세요."
  }, {
    "heading": "주요-변경-사항",
    "content": "2.0으로 업데이트하는 방법은 업그레이드 가이드를 참조하세요."
  }, {
    "heading": "구성",
    "content": "turbo.json의 주요 변경 사항은 npx @turbo/codemod migrate를 사용하여\n업데이트할 수 있습니다."
  }, {
    "heading": "구성",
    "content": "package.json의 turbo 필드 무시 (PR)"
  }, {
    "heading": "구성",
    "content": "Turborepo의 기본 디스크 캐시 위치가 node_modules/.cache에서 .turbo/cache로 이동 (PR)"
  }, {
    "heading": "구성",
    "content": "turbo.json의 pipeline 키가 tasks로 이름 변경 (PR)"
  }, {
    "heading": "구성",
    "content": "inputs/outputs의 디렉토리 파일 글로브가 디렉토리 내용 포함 (예: dist 및 dist/는 dist/**와 동일) (PR)"
  }, {
    "heading": "구성",
    "content": "명확성을 위해 outputMode 키를 outputLogs로 이름 변경하고 --output-logs 플래그와 일치시킴 (PR)"
  }, {
    "heading": "구성",
    "content": "이 변경 사항은 resolvedTaskConfig의 Run Summaries에 반영됩니다"
  }, {
    "heading": "구성",
    "content": "dependsOn 및 globalDependencies의 환경 변수 구문에서 오류 발생 (1.4 이후 더 이상 사용되지 않음) (PR)"
  }, {
    "heading": "구성",
    "content": "globalDotEnv 및 dotEnv 제거되고 inputs에 .env 파일 포함으로 대체 (PR)"
  }, {
    "heading": "구성",
    "content": "--ignore 제거되고 --filter 및 아래 그래프 정확성 변경 사항으로 대체 (PR)"
  }, {
    "heading": "정확성",
    "content": "환경 변수에 대한 Strict Mode가 이제 기본값이며 Loose Mode에서 변경됨 (PR)"
  }, {
    "heading": "정확성",
    "content": "Workspace 루트 디렉토리가 이제 모든 패키지의 암묵적 의존성임 (PR)"
  }, {
    "heading": "정확성",
    "content": "--scope 플래그 제거 (1.2 이후 더 이상 사용되지 않음) (PR)"
  }, {
    "heading": "정확성",
    "content": "패키지는 package.json에 name이 있어야 함 (PR)"
  }, {
    "heading": "정확성",
    "content": "루트 package.json의 packageManager 필드가 이제 필수임 (PR)"
  }, {
    "heading": "정확성",
    "content": "루트 package.json의 engines 필드가 이제 해싱에 사용됨 (PR)"
  }, {
    "heading": "정확성",
    "content": "--filter가 더 이상 패키지 이름에 대해 네임스페이스를 추론하지 않음 (PR)"
  }, {
    "heading": "정확성",
    "content": "--filter가 패키지 이름 또는 디렉토리가 일치하지 않을 때 오류 발생 (PR)"
  }, {
    "heading": "정확성",
    "content": "--only가 패키지 의존성만이 아닌 작업 의존성을 제한함 (PR)"
  }, {
    "heading": "기타",
    "content": "npm 및 pnpm의 최소 패키지 관리자 버전 지원이 8로 업데이트됨 (출처)"
  }, {
    "heading": "기타",
    "content": "create-turbo에서 패키지 관리자 인수 제거되고 옵션으로 대체됨 (PR)"
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo의 지속적인 성장과 채택을 보게 되어 기쁩니다:"
  }, {
    "heading": "커뮤니티",
    "content": "25.2k+ GitHub Stars"
  }, {
    "heading": "커뮤니티",
    "content": "2.3m+ 주간 NPM 다운로드"
  }, {
    "heading": "커뮤니티",
    "content": "Vercel Remote Cache를 사용하여 347년의 컴퓨팅 시간 절약"
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo는 핵심 팀을 포함한 모든 기여자들의 결합된 작업의 결과입니다: Anthony, Chris, Greg, Mehul, Mitch, Nicholas, 그리고 Tom."
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo를 여러분의 빌드 도구로 만들어 주시는 지속적인 지원, 피드백 및 협력에 감사드립니다. 아직 참여하지 않으셨다면 GitHub 및 Discord에서 대화에 참여하세요."
  }],
  "headings": [{
    "id": "새로운-터미널-ui",
    "content": "새로운 터미널 UI"
  }, {
    "id": "로그-명확성-개선",
    "content": "로그 명확성 개선"
  }, {
    "id": "상호작용-작업",
    "content": "상호작용 작업"
  }, {
    "id": "watch-mode",
    "content": "Watch Mode"
  }, {
    "id": "완전히-새로운-문서",
    "content": "완전히 새로운 문서"
  }, {
    "id": "주요-변경-사항",
    "content": "주요 변경 사항"
  }, {
    "id": "구성",
    "content": "구성"
  }, {
    "id": "정확성",
    "content": "정확성"
  }, {
    "id": "기타",
    "content": "기타"
  }, {
    "id": "커뮤니티",
    "content": "커뮤니티"
  }]
};
import {Authors} from '#components/authors';
import {Date} from '#components/blog/date';
import {Callout} from '#components/callout';
import {Video} from '#components/video';
export const toc = [{
  depth: 2,
  url: "#새로운-터미널-ui",
  title: _jsx(_Fragment, {
    children: "새로운 터미널 UI"
  })
}, {
  depth: 3,
  url: "#로그-명확성-개선",
  title: _jsx(_Fragment, {
    children: "로그 명확성 개선"
  })
}, {
  depth: 3,
  url: "#상호작용-작업",
  title: _jsx(_Fragment, {
    children: "상호작용 작업"
  })
}, {
  depth: 2,
  url: "#watch-mode",
  title: _jsx(_Fragment, {
    children: "Watch Mode"
  })
}, {
  depth: 2,
  url: "#완전히-새로운-문서",
  title: _jsx(_Fragment, {
    children: "완전히 새로운 문서"
  })
}, {
  depth: 2,
  url: "#주요-변경-사항",
  title: _jsx(_Fragment, {
    children: "주요 변경 사항"
  })
}, {
  depth: 3,
  url: "#구성",
  title: _jsx(_Fragment, {
    children: "구성"
  })
}, {
  depth: 3,
  url: "#정확성",
  title: _jsx(_Fragment, {
    children: "정확성"
  })
}, {
  depth: 3,
  url: "#기타",
  title: _jsx(_Fragment, {
    children: "기타"
  })
}, {
  depth: 2,
  url: "#커뮤니티",
  title: _jsx(_Fragment, {
    children: "커뮤니티"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 2.0"
    }), "\n", "\n", _jsx(Date, {
      children: "Tuesday, June 4, 2024"
    }), "\n", _jsx(Authors, {
      authors: ['chrisolszewski', 'nicholasyang']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 2.0은 JavaScript 및 TypeScript 저장소의 개발자 경험을 개선합니다. 주요 기능은 다음과 같습니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#new-terminal-ui",
          children: _jsx(_components.strong, {
            children: "새로운 터미널 UI"
          })
        }), ": 상호작용 가능한 작업과 더 명확한 로그"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#watch-mode",
          children: _jsx(_components.strong, {
            children: "Watch Mode"
          })
        }), ": 저장소의 모든 도구를 위한 의존성 인식 작업 감시자"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#all-new-documentation",
          children: _jsx(_components.strong, {
            children: "완전히 새로운 문서"
          })
        }), ": 핵심 monorepo 개념, 새로워진 API 참조 및 생태계 도구 가이드"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "라이선스 및 유지보수 업데이트"
        }), ": MIT 라이선스로 업그레이드 및 ", _jsx(_components.a, {
          href: "/docs/support-policy#lts-policy",
          children: "장기 지원 정책"
        }), " 추가"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "npx @turbo/codemod migrate"
      }), "를 실행하여 지금 업데이트하거나 ", _jsx(_components.code, {
        children: "npx create-turbo@latest"
      }), "로 시작하세요."]
    }), "\n", _jsxs(_components.p, {
      children: ["업데이트 지침은 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/upgrading#upgrading-to-20",
        children: "업그레이드 가이드"
      }), "를 참조하세요. ", _jsx(_components.a, {
        href: "#breaking-changes",
        children: "주요 변경 사항"
      }), "은 아래에 나열되어 있습니다."]
    }), "\n", _jsx(_components.h2, {
      id: "새로운-터미널-ui",
      children: "새로운 터미널 UI"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://turborepo.com/blog/turbo-1-13-0",
        children: "Turborepo 1.13"
      }), "에서 개선된 터미널 UI가 개발 속도를 어떻게 향상시킬 수 있는지 알아보기 위해 실험적 인터페이스를 출시했습니다. ", _jsx(_components.a, {
        href: "https://github.com/vercel/turbo/discussions/7802",
        children: "RFC 프로세스"
      }), "를 통해 여러분의 피드백을 바탕으로 커뮤니티와 함께 개선된 로컬 경험을 설계할 수 있었습니다. 참여해 주신 분들께 감사드립니다."]
    }), "\n", _jsx(_components.p, {
      children: "오늘, 새로운 UI를 안정 버전으로 출시하며, 이와 함께 많은 요청을 받았던 기능들을 활성화합니다."
    }), "\n", _jsx(Video, {
      src: "/images/blog/turbo-2-0/interactive-ui.mp4",
      width: "928",
      height: "522",
      className: "rounded"
    }), "\n", _jsx(_components.h3, {
      id: "로그-명확성-개선",
      children: "로그 명확성 개선"
    }), "\n", _jsxs(_components.p, {
      children: ["2.0 이전에는 ", _jsx(_components.code, {
        children: "turbo"
      }), "가 라이브러리 및 애플리케이션 작업 중에 로그를 스트림으로 출력했습니다. 이는 때때로 압도적일 수 있었는데, 섞인 로그들로 인해 특정 작업에서 무슨 일이 일어나고 있는지 이해하기 어려웠습니다."]
    }), "\n", _jsx(_components.p, {
      children: "이번 UI 반복에서는 화살표 키를 사용하여 개별 작업을 선택하고 한 번에 하나씩 로그를 검사할 수 있어, 집중하고 싶은 로그를 더 쉽게 읽을 수 있습니다."
    }), "\n", _jsx(Callout, {
      type: "good-to-know",
      children: _jsxs(_components.p, {
        children: ["이전 버전의 ", _jsx(_components.code, {
          children: "turbo"
        }), "에서 사용하던 스트림 로그 보기는 ", _jsx(_components.code, {
          children: "--log-order"
        }), " 플래그를\n사용하여 로컬 개발에서 여전히 사용할 수 있습니다. 이 옵션을 사용하면 작업이\n상호작용하지 않으며 일부 도구가 예기치 않게 터미널을 지울 수 있습니다."]
      })
    }), "\n", _jsx(_components.h3, {
      id: "상호작용-작업",
      children: "상호작용 작업"
    }), "\n", _jsxs(_components.p, {
      children: ["많은 도구들이 중요한 기능을 위해 스크립트와 상호작용할 수 있도록 허용합니다. 하지만 이전 버전의 Turborepo에서는 스크립트가 ", _jsx(_components.code, {
        children: "turbo"
      }), " 내부에 갇혀 있어 상호작용할 수 없었습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이제 개별 작업의 셸에 들어가서 인터페이스에 직접 입력하여 ", _jsx(_components.code, {
        children: "stdin"
      }), "을 통해 스크립트에 입력을 전달할 수 있습니다. 이를 통해 ", _jsx(_components.a, {
        href: "https://jestjs.io",
        children: "Jest"
      }), " 또는 ", _jsx(_components.a, {
        href: "https://vitest.dev/",
        children: "Vitest"
      }), "로 특정 테스트 스위트 실행, ", _jsx(_components.a, {
        href: "https://orm.drizzle.team/",
        children: "Drizzle"
      }), " 또는 ", _jsx(_components.a, {
        href: "https://www.prisma.io/",
        children: "Prisma"
      }), "로 데이터베이스 마이그레이션 처리 등의 워크플로우를 사용할 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["작업을 상호작용으로 표시하려면 정의에 ", _jsx(_components.code, {
        children: "\"persistent\": true"
      }), "를 추가하세요:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"cache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"persistent\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["UI에서 작업을 선택한 상태에서 ", _jsx(_components.code, {
        children: "Enter"
      }), " 키를 사용하여 작업의 셸에 진입하고 ", _jsx(_components.code, {
        children: "CTRL+Z"
      }), "로 종료할 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["지속적 및 상호작용 작업에 대해 자세히 알아보려면 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#persistent",
        children: "문서를 방문하세요"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "watch-mode",
      children: "Watch Mode"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo의 다중 작업 동시 실행 기능은 더 빠른 피드백 루프를 제공하여 신속한 배포를 지원합니다. 로컬에서 작업할 때 Turborepo의 병렬화를 최대한 활용하려면, 변경 사항이 있을 때마다 코드를 다시 실행할 수 있는 \"감시자\" 기능이 도구에 필요합니다. 안타깝게도 많은 일반 도구들이 이 기능을 제공하지 않으며, 대부분의 도구가 monorepo를 인식하지 못해 저장소의 다른 스크립트에 의존하는 스크립트에 문제가 발생합니다."
    }), "\n", _jsx(_components.p, {
      children: "오늘, 모든 도구에 이 기능을 제공하기 위해 Watch Mode를 출시합니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " watch"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " dev"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " lint"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " test"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo watch"
      }), "를 사용하면 Turborepo가 소스 코드 변경 시 작업을 다시 실행합니다. 작업은 ", _jsx(_components.code, {
        children: "turbo run"
      }), "과 마찬가지로 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "의 의존성 그래프 및 구성을 사용하여 실행됩니다."]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "/docs/crafting-your-repository/developing-applications#watch-mode",
        children: "문서에서 Watch Mode에 대해 자세히 알아보세요."
      })
    }), "\n", _jsx(_components.h2, {
      id: "완전히-새로운-문서",
      children: "완전히 새로운 문서"
    }), "\n", _jsx(_components.p, {
      children: "이번 릴리스와 함께 이전 버전의 강점을 기반으로 한 개선된 문서를 출판합니다. 여러분의 피드백을 반영하여 문서에는 다음이 포함됩니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "더 많은 monorepo 기본 사항 및 사용 방법"
      }), "\n", _jsx(_components.li, {
        children: "선호하는 도구를 Turborepo와 통합하는 가이드"
      }), "\n", _jsx(_components.li, {
        children: "더 명확한 정보 구조 및 개선된 검색"
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "/docs",
        children: "Turborepo 문서를 방문하세요."
      })
    }), "\n", _jsx(_components.h2, {
      id: "주요-변경-사항",
      children: "주요 변경 사항"
    }), "\n", _jsxs(_components.p, {
      children: ["2.0으로 업데이트하는 방법은 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/upgrading#upgrading-to-20",
        children: "업그레이드 가이드"
      }), "를 참조하세요."]
    }), "\n", _jsx(_components.h3, {
      id: "구성",
      children: "구성"
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "turbo.json"
        }), "의 주요 변경 사항은 ", _jsx(_components.code, {
          children: "npx @turbo/codemod migrate"
        }), "를 사용하여\n업데이트할 수 있습니다."]
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "package.json"
        }), "의 ", _jsx(_components.code, {
          children: "turbo"
        }), " 필드 무시 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8023",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["Turborepo의 기본 디스크 캐시 위치가 ", _jsx(_components.code, {
          children: "node_modules/.cache"
        }), "에서 ", _jsx(_components.code, {
          children: ".turbo/cache"
        }), "로 이동 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8126",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "turbo.json"
        }), "의 ", _jsx(_components.code, {
          children: "pipeline"
        }), " 키가 ", _jsx(_components.code, {
          children: "tasks"
        }), "로 이름 변경 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8157",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "inputs"
        }), "/", _jsx(_components.code, {
          children: "outputs"
        }), "의 디렉토리 파일 글로브가 디렉토리 내용 포함 (예: ", _jsx(_components.code, {
          children: "dist"
        }), " 및 ", _jsx(_components.code, {
          children: "dist/"
        }), "는 ", _jsx(_components.code, {
          children: "dist/**"
        }), "와 동일) (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8180",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["명확성을 위해 ", _jsx(_components.code, {
          children: "outputMode"
        }), " 키를 ", _jsx(_components.code, {
          children: "outputLogs"
        }), "로 이름 변경하고 ", _jsx(_components.code, {
          children: "--output-logs"
        }), " 플래그와 일치시킴 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8149",
          children: "PR"
        }), ")", "\n", _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["이 변경 사항은 ", _jsx(_components.code, {
              children: "resolvedTaskConfig"
            }), "의 Run Summaries에 반영됩니다"]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "dependsOn"
        }), " 및 ", _jsx(_components.code, {
          children: "globalDependencies"
        }), "의 환경 변수 구문에서 오류 발생 (1.4 이후 더 이상 사용되지 않음) (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8026",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "globalDotEnv"
        }), " 및 ", _jsx(_components.code, {
          children: "dotEnv"
        }), " 제거되고 ", _jsx(_components.code, {
          children: "inputs"
        }), "에 ", _jsx(_components.code, {
          children: ".env"
        }), " 파일 포함으로 대체 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8181",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--ignore"
        }), " 제거되고 ", _jsx(_components.code, {
          children: "--filter"
        }), " 및 아래 그래프 정확성 변경 사항으로 대체 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8201",
          children: "PR"
        }), ")"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "정확성",
      children: "정확성"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["환경 변수에 대한 Strict Mode가 이제 기본값이며 Loose Mode에서 변경됨 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8182",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["Workspace 루트 디렉토리가 이제 모든 패키지의 암묵적 의존성임 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8202",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--scope"
        }), " 플래그 제거 (1.2 이후 더 이상 사용되지 않음) (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/7970",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["패키지는 ", _jsx(_components.code, {
          children: "package.json"
        }), "에 ", _jsx(_components.code, {
          children: "name"
        }), "이 있어야 함 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8152",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["루트 ", _jsx(_components.code, {
          children: "package.json"
        }), "의 ", _jsx(_components.code, {
          children: "packageManager"
        }), " 필드가 이제 필수임 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8017",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["루트 ", _jsx(_components.code, {
          children: "package.json"
        }), "의 ", _jsx(_components.code, {
          children: "engines"
        }), " 필드가 이제 해싱에 사용됨 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8173",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--filter"
        }), "가 더 이상 패키지 이름에 대해 네임스페이스를 추론하지 않음 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8137",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--filter"
        }), "가 패키지 이름 또는 디렉토리가 일치하지 않을 때 오류 발생 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8142",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--only"
        }), "가 패키지 의존성만이 아닌 작업 의존성을 제한함 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8163",
          children: "PR"
        }), ")"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "기타",
      children: "기타"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["npm 및 pnpm의 최소 패키지 관리자 버전 지원이 8로 업데이트됨 (", _jsx(_components.a, {
          href: "/docs/support-policy#package-managers",
          children: "출처"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "create-turbo"
        }), "에서 패키지 관리자 인수 제거되고 옵션으로 대체됨 (", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo/pull/8150",
          children: "PR"
        }), ")"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "커뮤니티",
      children: "커뮤니티"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo의 지속적인 성장과 채택을 보게 되어 기쁩니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "25.2k+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.npmjs.com/package/turbo",
          children: "2.3m+ 주간 NPM 다운로드"
        })
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://vercel.com/docs/concepts/monorepos/remote-caching",
          children: "Vercel Remote Cache"
        }), "를 사용하여 347년의 컴퓨팅 시간 절약"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo는 핵심 팀을 포함한 모든 기여자들의 결합된 작업의 결과입니다: ", _jsx(_components.a, {
        href: "https://github.com/anthonyshew",
        children: "Anthony"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/chris-olszewski",
        children: "Chris"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/gsoltis",
        children: "Greg"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/mehulkar",
        children: "Mehul"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/Zertsov",
        children: "Mitch"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/NicholasLYang",
        children: "Nicholas"
      }), ", 그리고 ", _jsx(_components.a, {
        href: "https://github.com/tknickman",
        children: "Tom"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo를 여러분의 빌드 도구로 만들어 주시는 지속적인 지원, 피드백 및 협력에 감사드립니다. 아직 참여하지 않으셨다면 ", _jsx(_components.a, {
        href: "https://github.com/vercel/turbo",
        children: "GitHub"
      }), " 및 ", _jsx(_components.a, {
        href: "/discord",
        children: "Discord"
      }), "에서 대화에 참여하세요."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
